var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentLogoFedex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 40,
    viewBox: "0 0 80 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.6299 30.2829L66.6808 26.9755L63.7575 30.2829H57.6064L63.6182 23.5288L57.6064 16.7727H63.9496L66.9286 20.0547L69.7951 16.7727H75.9164L69.9345 23.5004L75.9995 30.2829H69.6299ZM45.7949 30.2829V9H57.6064V13.7439H50.7981V16.7727H57.6064V21.3375H50.7981V25.5271H57.6064V30.2829H45.7949Z",
    fill: "#FF5A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8109 9V17.7101H40.7557C39.6526 16.4423 38.2738 16.0004 36.6751 16.0004C33.399 16.0004 30.931 18.2291 30.0647 21.1733C29.0765 17.9286 26.5284 15.9397 22.7508 15.9397C19.6822 15.9397 17.26 17.3165 15.9947 19.5606V16.7722H9.653V13.7444H16.5743V9.001H4V30.2829H9.653V21.3375H15.2876C15.114 22.0254 15.0273 22.7323 15.0294 23.4417C15.0294 27.8791 18.4204 30.9975 22.7498 30.9975C26.3891 30.9975 28.7894 29.2873 30.0577 26.1739H25.2128C24.558 27.1109 24.0604 27.3875 22.7503 27.3875C21.2317 27.3875 19.9211 26.062 19.9211 24.4926H29.7861C30.214 28.018 32.9606 31.0577 36.7303 31.0577C38.3564 31.0577 39.8451 30.2581 40.7552 28.9071H40.8099V30.2859H45.7942V9.001H40.8109V9V9ZM20.0783 21.4012C20.3933 20.0487 21.4417 19.165 22.7503 19.165C24.1913 19.165 25.1864 20.0214 25.4477 21.4012H20.0783ZM37.7862 27.0442C35.9496 27.0442 34.8081 25.333 34.8081 23.5457C34.8081 21.635 35.8013 19.7995 37.7862 19.7995C39.8456 19.7995 40.6661 21.636 40.6661 23.5457C40.6661 25.3559 39.7974 27.0442 37.7862 27.0442Z",
    fill: "#29007C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLogoFedex);
export default __webpack_public_path__ + "static/media/payment-logo-fedex.ff27cbe04e58d835e97174fdd2cd9cae.svg";
export { ForwardRef as ReactComponent };